import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { supabase } from '../../lib/supabase';

const AuthCallback: React.FC = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const { data: { session }, error } = await supabase.auth.getSession();
        
        if (error) {
          console.error('Auth error:', error);
          setError('Authentication error occurred');
          return;
        }

        if (session?.user) {
          // Let AuthContext handle the redirection through onAuthStateChange
          // No need to manually redirect here
          console.log('OAuth callback successful, AuthContext will handle redirection');
        } else {
          setError('No session found');
        }
      } catch (err) {
        console.error('Auth callback error:', err);
        setError('An unexpected error occurred');
      }
    };

    checkAuth();
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8 text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
        <h2 className="text-xl font-semibold text-gray-900 mb-2">
          {loading ? 'Signing you in...' : 'Checking your account...'}
        </h2>
        <p className="text-gray-600">
          {loading 
            ? 'Please wait while we complete your sign-in.'
            : 'Please wait while we determine where to redirect you.'
          }
        </p>
        {error && (
          <p className="text-red-600 mt-4">
            {error}
          </p>
        )}
      </div>
    </div>
  );
};

export default AuthCallback; 